import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import classnames from 'classnames';
import { toastr } from 'react-redux-toastr';
import DualListBox from 'react-dual-listbox';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';

import '../../dump/menuComponents/menuComponents.sass';

import { getDevicesList } from '../../../../../shared/api/action/DeviceActions';
import {
	addEquipmentToGroup,
	getEquipmentsList,
	getEquipmentsOfGroup,
	removeEquipmentFromGroup,
} from '../../../../../shared/api/action/EquipmentActions';
import { getUsers } from '../../../../../shared/api/action/ClientActions';
import {
	getDevicesOfGroup,
	getCompanyGroups,
	getUsersOfGroup,
	addDeviceToGroup,
	removeDeviceFromGroup,
	addUserToGroup,
	removeUserFromGroup,
	editGroup,
	getGroupData,
	deleteGroup, toggleDriverToGroup
} from '../../../../../shared/api/action/GroupsActions';
import { errorDetection } from '../../helpers/helperErrors';

import GreyHeader from '../../../../../shared/ui/GreyHeader';
import CustomButton from '../../CustomButton';
import { getCompanyDrivers } from "../../../../../shared/api/action/CompaniesActions";

const EditGroupContainer = (props) => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'manageGroupsPage.editGroupContainer' });
	const { user, toggleLoader } = props;
	const userRole = user.roles[0];
	const company = location.state.company;

	const [group, setGroup] = useState({})
	const [initialGroup, setInitialGroup] = useState(location.state.group)

	const [allEquipments, setAllEquipments] = useState([])
	const [groupEquipments, setGroupEquipments] = useState([])
	const [changedEquipments, setChangedEquipments] = useState([])

	const [allDevices, setAllDevices] = useState([])
	const [groupDevices, setGroupDevices] = useState([])
	const [changedDevices, setChangedDevices] = useState([])

	const [allUsers, setAllUsers] = useState([])
	const [groupUsers, setGroupUsers] = useState([])
	const [changedUsers, setChangedUsers] = useState([])

	const [allDrivers, setAllDrivers] = useState([])
	const [groupDrivers, setGroupDrivers] = useState([])
	const [changedDrivers, setChangedDrivers] = useState([])

	const [errMessage, setErrMessage] = useState({
		err_group_name: '',
	})
	const [modal, setModal] = useState({
		show: false,
		error: false
	})
	const [deletedGroup, setDeletedGroup] = useState({})
	const [groups, setGroups] = useState()
	const [upd, setUpd] = useState(false)


	useEffect(() => {
		getGroup();

		return () => {
			localStorage.removeItem("selectGroup");
		}
	}, []);

	const getGroup = () => {
		toggleLoader(true);
		const params = {
			id: location.state.group.id,
			partner_name: company.partner,
			company_name: company.name,
			user_role: userRole,
		}
		getGroupData(params)
			.then((res) => {
				const result = res.data.response.groups[0];
				const initGroup = {
					group_name: result.group_name,
					id: result.id,
				}
				setGroup(initGroup)
				getAllData(result.group_name, result.id)
			})
			.catch((error) => {
				console.log('!getGroupData error', error);
				toggleLoader(false);
			});
	}

	const getAllData = async (argGroupName, argGroupId) => {
		const groupName = argGroupName || group.group_name || initialGroup.group_name;
		const groupId = argGroupId || group.id || initialGroup.id;
		const requestArray = [];

		if (groupName && groupName.length > 0) {
			toggleLoader(true);

			// gets the company devices list and devices assigned to group
			requestArray.push(getDevicesList(company.company_id));
			const params = {
				company_name: company.name,
				partner_name: company.partner,
				group_name: groupName,
				user_role: userRole,
			}
			requestArray.push(getDevicesOfGroup(params));

			// gets the company users and users assigned to group
			const paramsCompany = {
				name: company.name,
				partner: company.partner,
			};
			requestArray.push(getUsers(userRole, paramsCompany))
			requestArray.push(getUsersOfGroup(params))

			// gets the company drivers
			requestArray.push(getCompanyDrivers({ companyId: company.company_id }))

			//equipments
			requestArray.push(getEquipmentsList(company.company_id));
			requestArray.push(getEquipmentsOfGroup({ ...params, groupId }));

			const group_name = localStorage.getItem("selectGroup") || initialGroup.group_name;

			await Promise.all(requestArray)
				.then(
					(res) => {
						let allDevices, groupDevices, allUsers, groupUsers, allDrivers, groupDrivers, allEquipmentsList,  groupEquipmentsList;

						if (res[0].status === 200 || res[0].status === 201) {
							const { devices } = res[0].data.response
							const filteredDevices = devices.filter(item => !item.group_name || item.group_name === group_name)
							allDevices = filteredDevices.map((device) => {
								return { label: device.vehicle_name || device.driver_name || device.device_id, value: device.device_id.toString() }
							})
						}

						if (res[1].status === 200 || res[1].status === 201) {
							const { devices } = res[1].data.response
							groupDevices = devices.map(({ device_id }) => device_id.toString())
						}

						if (res[2].status === 200 || res[2].status === 201) {
							const { users } = res[2].data.response
							const filteredUsers = users.filter((item) => { if (item.roles[0] === 'user') return item })
							allUsers = filteredUsers.map(({ email }) => email)
						}

						if (res[3].status === 200 || res[3].status === 201) {
							groupUsers = res[3].data.response.users;
						}

						if (res[4].status === 200 || res[4].status === 201) {
							const { drivers } = res[4].data.response
							const filteredDrivers = drivers.filter(item => !item.group_name || item.group_name === group_name)
							allDrivers = filteredDrivers.map((driver) => {
								return { label: driver.name || driver.email, value: driver.id.toString() }
							})
							groupDrivers = filteredDrivers.filter((item) => item.group_name === group_name).map(({ id }) => id.toString())
						}

						if (res[5].status === 200 || res[5].status === 201) {
							const { trackers } = res[5].data.response
							const filteredEquipments = trackers.filter(item => !item.group_name || item.group_name === group_name)
							allEquipmentsList = filteredEquipments.map((equipment) => {
								return { label: equipment.name || equipment.beacon_id, value: equipment.beacon_id }
							})
						}

						if (res[6].status === 200 || res[6].status === 201) {
							const trackers = res[6].data.response || [];
							groupEquipmentsList = trackers.map(({ beacon_id }) => beacon_id)
						}

						setAllDevices(allDevices)
						setGroupDevices(groupDevices)
						setChangedDevices(groupDevices)

						setAllUsers(allUsers)
						setGroupUsers(groupUsers)
						setChangedUsers(groupUsers)

						setAllDrivers(allDrivers)
						setGroupDrivers(groupDrivers)
						setChangedDrivers(groupDrivers)

						setAllEquipments(allEquipmentsList)
						setGroupEquipments(groupEquipmentsList)
						setChangedEquipments(groupEquipmentsList)

						toggleLoader(false);

					}, (error) => {
						console.log('getAllData PromiseAll ERROR', error);
						toggleLoader(false);
						let errDescription = i18n.t('errorMessage.errDescription');
						if (error?.response?.data?.response?.error) {
							errDescription = error.response.data.response.error
						}
						toastr.error(errDescription)
					});
		}
	}

	const checkForm = async (data) => {
		let error = false;
		let errMessageUpdate = errMessage;

		if (data.group_name.includes('/')) {
			error = true;
			errMessageUpdate['err_group_name'] = `${t('errGroupName')} "/"`
		} else {
			for (let i in data) {
				if (data[i] === '') {
					error = true;
					let message = i.replaceAll('_', ' ');
					errMessageUpdate['err_' + i] = t('pleaseEnter') + message;
				}
				else if (errMessageUpdate['err_' + i]) {
					errMessageUpdate['err_' + i] = null;
				}
			}
		}
		if (!errMessageUpdate['err_group_name'] && !/^[a-zA-Z0-9 ]+$/.test(data.group_name.trim())) {
			error = true;
			toastr.error(t('errValidGroupName'))
		}
		//checking if name already exists
		try {
			const response = await getCompanyGroups(userRole, company);
			let existing_groups = response.data.response.groups;
			existing_groups = existing_groups.filter(element => element !== initialGroup.group_name);

			if (existing_groups.includes(data.group_name.trimEnd())) {
				error = true;
				errMessageUpdate['err_group_name'] = t('errNameAlreadyExists')
			}
		} catch (error) {
			console.error('Error:', error);
		}

		setErrMessage(errMessageUpdate);
		console.log(error)
		return error;
	}

	const onSaveClick = async () => {
		let requestArray = [];
		const groupData = {
			company_name: company.name,
			partner_name: company.partner,
			user_role: userRole,
			group_name: group.group_name.trim(),
			id: group.id
		}

		const error = await checkForm(group);
		setUpd(!upd);

		if (!error) {
			toggleLoader(true);
			localStorage.setItem("selectGroup", group.group_name);

			if (group.group_name !== initialGroup.group_name) {
				requestArray.push(await editGroup(groupData))
			}

			if (!_.isEqual(_.sortBy(changedDevices), _.sortBy(groupDevices))) {
				// adds devices to group
				_.difference(changedDevices, groupDevices).forEach((deviceId) => {
					requestArray.push(addDeviceToGroup(groupData, deviceId))
				})
				// removes devices from group
				_.difference(groupDevices, changedDevices).forEach((deviceId) => {
					requestArray.push(removeDeviceFromGroup(groupData, deviceId))
				})
			}

			if (!_.isEqual(_.sortBy(changedUsers), _.sortBy(groupUsers))) {
				// adds users to group
				_.difference(changedUsers, groupUsers).forEach((userEmail) => {
					requestArray.push(addUserToGroup(groupData, userEmail))
				})
				// removes users from group
				_.difference(groupUsers, changedUsers).forEach((userEmail) => {
					requestArray.push(removeUserFromGroup(groupData, userEmail))
				})
			}

			if (!_.isEqual(_.sortBy(changedEquipments), _.sortBy(groupEquipments))) {
				// adds equipments to group
				_.difference(changedEquipments, groupEquipments).forEach((beacon_id) => {
					requestArray.push(addEquipmentToGroup(group.id, beacon_id))
				})
				// removes equipments from group
				_.difference(groupEquipments, changedEquipments).forEach((beacon_id) => {
					requestArray.push(removeEquipmentFromGroup(group.id, beacon_id))
				})
			}

			if (!_.isEqual(_.sortBy(changedDrivers), _.sortBy(groupDrivers))) {
				// adds drivers to group
				_.difference(changedDrivers, groupDrivers).forEach((driverId) => {
					requestArray.push(toggleDriverToGroup({ driver_id: driverId, group_id: groupData.id, group_name: groupData.group_name }))
				})
				// removes drivers from group
				_.difference(groupDrivers, changedDrivers).forEach((driverId) => {
					requestArray.push(toggleDriverToGroup({ driver_id: driverId, group_id: '', group_name: '' }))
				})
			}

			Promise.all(requestArray)
				.then(res => {
					if (res.length > 0) {
						if (res[0] && (res[0].status === 200 || res[0].status === 201)) {
							setInitialGroup(group);
							getGroup();
							toggleLoader(false);
							toastr.success('', t('changesSaved'));
						}
					} else {
						toggleLoader(false);
						toastr.info('', t('noChanges'));
					}
				})
				.catch(err => {
					toggleLoader(false);
					console.log('Promise.all error: ', err.response);

					let errDescription = t('unableUpdateGroup');
					if (err.response.data.body) {
						errDescription = errorDetection(err.response.data.body) || err.response.data.body
					}
					else if (err.response.data.response.error) {
						errDescription = errorDetection(err.response.data.response.error) || err.response.error
					}
					toastr.error(errDescription)
				});
		}
	}

	const onCancelClick = () => {
		navigate('/managegroups');
	}

	const handleInputChange = (event) => {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		let data = group;
		data[name] = value;

		setGroup(data);
		setErrMessage({ group_name: '' });
	}

	const deleteGroupConfirm = () => {
		setDeletedGroup(group);
		setModal({ ...modal, show: true });
	}

	const deleteGroupModal = () => {
		toggleLoader(true);
		const data = {
			group_name: deletedGroup.group_name,
			user_role: userRole,
			company_name: props.company.name,
			partner_name: props.company.partner
		}

		if (group.group_name) {
			deleteGroup(data)
				.then(res => {
					let modalUpdate = modal;
					modalUpdate['show'] = false;
					let getGroups = res.data.response.groups;
					setDeletedGroup({});
					setModal(modalUpdate);
					setGroups(getGroups);
					toastr.success('', t('groupDeleted'));
					onCancelClick();
					toggleLoader(false);
				})
				.catch(error => {
					toggleLoader(false);
					console.log('!deleteGroupModal error: ', error.response, error)
					let errDescription = i18n.t('errorMessage.errDescription');
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				});
		}
	}

	const closeModal = () => {
		setModal({ ...modal, show: false });
	}

	const { err_group_name } = errMessage;
	const hasDeletePermission = !['custom_user', 'custom_partner'].includes(user.roles[0])
		|| _.find(user.permissions, { perm_category_id: 6, a_delete: true });
	const hasEditPermission = !['custom_user', 'custom_partner'].includes(user.roles[0])
		|| _.find(user.permissions, { perm_category_id: 6, a_edit: true });
	const editableName = !['MASTER GROUP', 'Installed Devices'].includes(location.state.group.group_name);

	const optionsDevicesMobile = []
	const selectedDevicesMobile = []
	const optionsEquipmentsMobile = []
	const selectedEquipmentsMobile = []
	const optionsUsersMobile = []
	const optionsDriversMobile = []
	const selectedDriversMobile = []

	const optionsDevices = []
	allDevices.forEach((item) => {
		optionsDevices.push({ value: item.value, label: item.label })

		if (changedDevices.indexOf(item.value) === -1) {
			optionsDevicesMobile.push(item.label)
		} else {
			selectedDevicesMobile.push(item.label)
		}
	})

	const optionsEquipments = []
	allEquipments.forEach((item) => {
		optionsEquipments.push({ value: item.value, label: item.label })

		if (changedEquipments.indexOf(item.value) === -1) {
			optionsEquipmentsMobile.push(item.label)
		} else {
			selectedEquipmentsMobile.push(item.label)
		}
	})

	const optionsUsers = []
	allUsers.forEach(item => {
		optionsUsers.push({ value: item, label: item });

		if (changedUsers.indexOf(item) === -1) {
			optionsUsersMobile.push(item)
		}
	})

	const optionsDrivers = []
	allDrivers.forEach((item) => {
		optionsDrivers.push({ value: item.value, label: item.label })

		if (changedDrivers.indexOf(item.value) === -1) {
			optionsDriversMobile.push(item.label)
		} else {
			selectedDriversMobile.push(item.label)
		}
	})

	if (!changedDevices || !changedUsers || !changedDrivers) {
		return (
			<GreyHeader title={t('titleEditGroup')} hideSubtitle />
		)
	}

	return (
		<div className='edit-group'>
			<GreyHeader title={t('titleEditGroup')} subtitle={localStorage.getItem("selectGroup") || initialGroup.group_name} />

			<div className={`page-subheader ${editableName ? '' : 'align-right'}`}>
				{editableName && (
					<div className={classnames('subheader-section search-flex', { 'has-error': err_group_name })}>
						<label className='search-label'>{t('labelName')}</label>
						<input
							type="text"
							name="group_name"
							className="vehicle-search"
							onChange={handleInputChange}
							value={group.group_name || ''}
						/>
						{err_group_name && <span className="help-block">{err_group_name}</span>}
					</div>
				)}
				<div className='subheader-section'>
					<CustomButton variant="secondary" onClick={onSaveClick} disabled={!hasEditPermission}>{t('btnSave')}</CustomButton>
					<CustomButton variant="secondary-outline" onClick={onCancelClick}>{t('btnBack')}</CustomButton>
					{hasDeletePermission &&
						<CustomButton variant="delete" onClick={deleteGroupConfirm}>{t('btnDelete')}</CustomButton>
					}
				</div>
			</div>

			<main className='main-content-block'>
				<section>
					<h3 className='category-title'>{t('titleVehicles')}</h3>
					<div className="dual-list-label">
						<label htmlFor="groups" className="control-label">
							{t('availableVehicles')}
						</label>
						<label htmlFor="groups" className="control-label">
							{`${t('vehiclesIn')} ${group.group_name}:`}
						</label>
					</div>
					<div
						className={`dual-listbox-wrapper ${location.state.group.group_name === 'Installed Devices' && 'disable-assign'}`}>
						<DualListBox
							name="devices"
							canFilter
							options={optionsDevices}
							selected={changedDevices}
							onChange={(selected) => setChangedDevices(selected)}
						/>

						{isMobileOnly && (
							<div className='mobile-dual-list-wrapper'>
								<textarea value={optionsDevicesMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
								<textarea value={selectedDevicesMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
							</div>
						)}
					</div>
				</section>

				<section>
					<h3 className='category-title'>{t('titleNonVehicles')}</h3>
					<div className="dual-list-label">
						<label htmlFor="groups" className="control-label">
							{t('availableNonVehicles')}
						</label>
						<label htmlFor="groups" className="control-label">
							{`${t('nonVehiclesIn')} ${group.group_name}:`}
						</label>
					</div>
					<div
						className={`dual-listbox-wrapper ${location.state.group.group_name === 'Installed Devices' && 'disable-assign'}`}>
						<DualListBox
							name="equipments"
							canFilter
							options={optionsEquipments}
							selected={changedEquipments}
							onChange={(selected) => setChangedEquipments(selected)}
						/>

						{isMobileOnly && (
							<div className='mobile-dual-list-wrapper'>
								<textarea value={optionsEquipmentsMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
								<textarea value={selectedEquipmentsMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
							</div>
						)}
					</div>
				</section>

				<section>
					<h3 className='category-title'>{t('titleUsers')}</h3>
					<div className="dual-list-label">
						<label htmlFor="users" className="control-label">
							{t('availableUsers')}
						</label>
						<label htmlFor="users" className="control-label">
							{`${t('usersAssigned')} ${group.group_name}:`}
						</label>
					</div>
					<DualListBox
						name="users"
						canFilter
						options={optionsUsers}
						selected={changedUsers}
						onChange={(selected) => setChangedUsers(selected)}
					/>

					{isMobileOnly && (
						<div className='mobile-dual-list-wrapper'>
							<textarea value={optionsUsersMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
							<textarea value={changedUsers.join('\r\n')} readOnly className="textarea-duallistbox"/>
						</div>
					)}
				</section>

				<section>
					<h3 className="category-title">{t('titleDrivers')}</h3>
					<div className="dual-list-label">
						<label htmlFor="drivers" className="control-label">
							{t('availableDrivers')}
						</label>
						<label htmlFor="drivers" className="control-label">
							{`${t('driversAssigned')} ${group.group_name}:`}
						</label>
					</div>
					<DualListBox
						name="drivers"
						canFilter
						options={optionsDrivers}
						selected={changedDrivers}
						onChange={selected => setChangedDrivers(selected)}
						preserveSelectOrder
					/>

					{isMobileOnly && (
						<div className="mobile-dual-list-wrapper">
							<textarea value={optionsDriversMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
							<textarea value={selectedDriversMobile.join('\r\n')} readOnly className="textarea-duallistbox"/>
						</div>
					)}
				</section>
			</main>

			<Modal
				show={modal.show}
				dialogClassName="has-error"
				onHide={closeModal}
				className="modal-lg-size"
			>
				<Modal.Header closeButton>
					<Modal.Title className="delete-title">{t('titleDeleteGroup')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text text-center">
						{t('deleteGroup')} <strong>{group.group_name}</strong>?
					</div>
				</Modal.Body>
				<Modal.Footer bsPrefix="default-modal-footer modal-footer">
					<CustomButton
						variant="delete"
						onClick={deleteGroupModal}
					>
						{t('btnModalDelete')}
					</CustomButton>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({type: 'TOGGLE_LOADER', payload: show});
		}
	})
)(EditGroupContainer);
